export default __webpack_public_path__ + "static/media/garage-project-logo.b747ddcb.svg";